import React from 'react'
import Navbar from '../../Comman_Layout/Header/Navbar'
import Footer from '../../Comman_Layout/Footer/Footer'
import Gotop from '../../Comman_Layout/Gotop'
import JohnBullBanner from './JohnBullBanner'
import JohnBullMainContent from './JohnBullMainContent'
import { Helmet } from 'react-helmet-async'
const JohnBullProject = () => {
  return (
    <>
      {
        <Helmet>
          <title> Our success stories in Web & Software | Alobha Technologies </title>
          <meta name="description" content="Build World-Class Software, Mobile Apps, Websites and Online Stores with Alobha Technologies. We provide ERP, CRM & Digital Marketing Services." />
          <meta name="keywords" content="software development company, software outsourcing, mobile apps, web design, website design, web developer, ecommerce website, web design company, web design software, software company, application development, mobile development, game development software, erp software, CRM Software, IVR Software, Blockchain, Digital marketing Company, Best IT Company India, Mobile app development company noida, Software Development Company, Web Development Company, Ecommerce Website Development Company, Website Design and Development Company, Mobile App Development Company, Digital Marketing Agency, Digital Marketing Company, Full Stack Web Development, ERP Software Development Company, Android App Development Company, Ios App Development Company, App Development Company in Noida, Best Software Development Company in Noida" />
        </Helmet>
      }
      <Navbar />
      <JohnBullBanner />
      <JohnBullMainContent />
      <Footer />
      <Gotop />
    </>
  )
}

export default JohnBullProject